import { useRouteError, useNavigate, isRouteErrorResponse } from "react-router-dom";

import { Container, Box, useTheme } from '@mui/material';

import { FilledButton, Typography } from '@initia-digital/component-library';

import { BasicPublicAppBarPage } from "../layouts/BasicPublicAppBarPage";


export const ErrorPage = () => {
    // --------------------------------------------------
    const error = useRouteError() as Error;
    console.error(error);

    const theme = useTheme();
    const navigate = useNavigate();

    const shouldDisplayRouteError = isRouteErrorResponse(error);


    return (
        <BasicPublicAppBarPage>
            <Container maxWidth="md">
                <Box id="error-page" display="flex" flexDirection="column" alignItems="center" justifyContent="center" flexGrow={1}>
                    <Box my="20px">
                        <Typography 
                            variant="h5" 
                            color={theme.palette.secondary.main} 
                            align="center"
                            fontSize="1.4rem"
                        >
                                Sorry, an unexpected error has occurred.
                        </Typography>
                    </Box>
                    <Box my="20px">
                    {
                        shouldDisplayRouteError &&
                        <Typography variant="body1">
                            <i>{error.statusText || error.message}</i>
                        </Typography>
                    }
                    {
                        !shouldDisplayRouteError &&
                        <>                    
                            <Typography variant="body1" fontSize="1.4rem" align="center">
                                <strong>{error.name}</strong>
                            </Typography>
                            <Typography variant="body1" fontSize="0.8rem">
                                <i>{error.message}</i>
                            </Typography>
                        </>
                    }
                    </Box>
                    <Box display="flex" my="10px">
                        <FilledButton
                            backgroundColor={theme.palette.secondary.main}
                            color='white'
                            onClick={() => {
                                navigate('/')
                            }}
                            tooltipTitle={`Go to home`}
                        >
                            Home
                        </FilledButton>
                    </Box>
                </Box>
            </Container>
        </BasicPublicAppBarPage>
    );
}